<template>
	<div class="width-100 display-flex flex-row">
		<div @click="selectConnection" class="selector-field-container flex-centerize width-100 px-2" :class="{ selected: isSelected }">
			<WidgetFieldWrapper
				ignoreRequired
				hideExplanation
				:field="populatedField"
				@update-value="updateValue"
				:fieldValue="fieldResponse"
				class="width-100 field-container px-1 py-2 mt-2"
			/>
		</div>
		<AnemicButton @click="selectConnection" class="select-button" :class="{ selected: isSelected }">
			{{ isSelected ? 'Selected' : 'Select' }}
		</AnemicButton>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import WidgetFieldWrapper from '@/components/WidgetForm/WidgetFieldWrapper.vue';
import WorkflowConfigurationService from '@/utils/workflow-configuration-service';
import { saveConfigurationFieldResponse } from '@/store/modules/workflowConfigurations/actions';
import {
	getConfigurationInterface,
	getConfigurationFieldResponse,
	getConfigurationFieldsIdsPerInterface,
} from '@/store/modules/workflowConfigurations/getters';
import VModelMixin from '@/mixins/VModelMixin';
export default {
	name: 'InterfaceBlocksSelectorItem',
	components: {
		WidgetFieldWrapper,
	},
	mixins: [VModelMixin],
	props: {
		field: { type: Object },
		configurationId: { type: Number },
	},
	computed: {
		...mapGetters([
			getConfigurationInterface.fullPath,
			getConfigurationFieldResponse.fullPath,
			getConfigurationFieldsIdsPerInterface.fullPath,
		]),
		isSelected() {
			return this.localValue === this.field.id;
		},
		configurationInterfaceUUID() {
			return WorkflowConfigurationService.getConfigurationInterfaceFromField(
				this.configurationId,
				this.field.id,
				this[getConfigurationFieldsIdsPerInterface.fullPath]
			);
		},
		fieldResponse() {
			return this[getConfigurationFieldResponse.fullPath](this.configurationId, this.field.id);
		},
		configurationInterface() {
			return this[getConfigurationInterface.fullPath](this.configurationId, this.configurationInterfaceUUID);
		},
		populatedField() {
			return this.configurationInterface?.fields.find((field) => field.id === this.field.id);
		},
	},
	methods: {
		...mapActions([saveConfigurationFieldResponse.fullPath]),
		async updateValue({ value }) {
			// does it make sense on all interface fields that can appear in selector? maybe we should make sure fieldType is allowed for this? (for example: ConnectionSelector)
			await this[saveConfigurationFieldResponse.fullPath]({
				id: this.configurationId,
				interfaceUUID: this.configurationInterfaceUUID,
				fieldUUID: this.field.id,
				response: value,
			});
		},
		selectConnection() {
			this.localValue = this.field.id;
		},
	},
};
</script>

<style scoped lang="scss">
.selector-field-container {
	cursor: pointer;
	border-radius: 10px;
	background: #f6f8fc83;
	border: 2px solid transparent;
	&.selected {
		border: 2px solid var(--primary-color);
	}
	.field-container {
		border-radius: 10px;
		background: var(--bg-color);
		border: 1px solid var(--border-color);
	}
}

.select-button {
	width: 57px;
	margin-left: 6px;
	border-radius: 10px;
	height: 100% !important;
	min-height: 99px !important;
	background: var(--soft-grey-background) !important;

	font-size: 12px !important;
	color: var(--primary-font-color);

	&.selected {
		color: var(--bg-color);
		background: var(--primary-color) !important;
	}
}
</style>
